import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const StyledSectionNote = styled.div<{ $highlight?: boolean }>`
    display: flex;
    padding: ${getPurpurSpacing('300')};
    gap: ${getPurpurSpacing('200')};
    border-radius: ${getPurpurBorder('radiusMd')};
    color: ${(props) => (props.$highlight ? getPurpurColor('textToneOnToneTertiary') : getPurpurColor('textDefault'))};
    background-color: ${(props) =>
        props.$highlight ? getPurpurColor('backgroundToneOnToneQuaternary') : 'transparent'};
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('150')};
    padding: ${getPurpurSpacing('100')} 0 ${getPurpurSpacing('100')} ${getPurpurSpacing('200')};
    border-left: ${getPurpurSpacing('25')} solid currentcolor;

    [class^='_purpur-paragraph'] {
        color: currentcolor;
    }

    ul,
    ol {
        display: flex;
        flex-direction: column;
        gap: ${getPurpurSpacing('150')};
        padding-left: 1.4rem;
        margin-top: 0;
    }
`;

export const NoteTitle = styled.div`
    font-size: ${getPurpurTypography('scale75')};
    line-height: ${getPurpurTypography('lineHeightTight')};
    font-weight: ${getPurpurTypography('weightMedium')};
    letter-spacing: ${getPurpurSpacing('10')};
    text-transform: uppercase;

    ${purpurMedia('md')`
      font-size: ${getPurpurTypography('scale100')};
    `};
`;
